import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

interface RemoveBasketAllItemsPayloadType {
  vendorId: number | undefined | null;
}

type RemoveBasketAllItems = (
  params: RemoveBasketAllItemsPayloadType
) => Promise<[]>;

const removeBasketAllItems: RemoveBasketAllItems = async (
  payload: RemoveBasketAllItemsPayloadType
) => {
  const client = new Client();

  return await client.delete(`/v1/Basket/Shopper/RemoveAll`, {}, payload);
};

export const useRemoveBasketAllItems = () => {
  return useMutation({
    mutationFn: removeBasketAllItems,
    retry: 1,
  });
};
